import FieldSet from '../../FieldSet';

import { TargetMetric } from './TargetMetric';
import { StartingMetric } from './StartingMetric';
import { CurrentMetric } from './CurrentMetric';

export class MetricsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [TargetMetric, StartingMetric, CurrentMetric];
  }

  get title() {
    return 'Metrics';
  }
}
